import React from 'react';
import EditItemForm from '../components/EditItemForm';

const EditItemScreen = ({ user, setView, itemIdToEdit }) => {
  return (
    <div>
      <div className="page-header">
        <h2>Edit Individual Item</h2>
        {/* The setView function passed from App.js will handle returning to the overview */}
        <button type="button" className="cancel-button" onClick={setView}>
            Back to Overview
        </button>
      </div>
      <p>Modify the unique details for this specific item, such as its size, color, or individual selling price. Changes here will not affect other items in the same batch.</p>
      
      <EditItemForm 
        user={user} 
        setView={setView} 
        itemId={itemIdToEdit}
      />
    </div>
  );
};

export default EditItemScreen;